import { FeatureFlags } from '@constants/featureFlags';
import { createAppStore } from '@store/createAppStore';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';

import { CollectionFlagState } from './types';

const [collectionFlagStore, setCollectionFlagStore] =
  createAppStore<CollectionFlagState>(
    {
      customerId: null,
      flags: [],
      selectedFlag: null,
      modalMode: 'add',
      deletingFlagId: null,
    },
    'collectionFlagStore',
  );

const canFlagCollections = isFeatureFlagEnabled(
  FeatureFlags.PermissionCustomerCollectionFlag,
);

export { canFlagCollections, collectionFlagStore, setCollectionFlagStore };
